exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reason-dialog__text[data-v-0c94514d]{padding:.26666667rem .4rem .42666667rem;-webkit-box-sizing:border-box;box-sizing:border-box;background:#f5f7f9;border-radius:.21333333rem;border:1px solid #e6e7e8;margin-top:.34666667rem}.reason-dialog__text[data-v-0c94514d] .weui_textarea{background-color:#f5f7f9}", ""]);

// exports
